if (!customElements.get('sevenk-hero-slider')) {
  class SevenKHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.track = this.querySelector('.sevenk-hero__track');
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Number(this.dataset.interval) || 5000;

      if (this.slides.length < 2) return;

      this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true)));

      this.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.addEventListener('pointercancel', (event) => this.onPointerUp(event));
      this.addEventListener('click', (event) => {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }, true);

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));

      this.show(this.currentIndex);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(index, restart = false) {
      const nextIndex = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === nextIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === nextIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      this.currentIndex = nextIndex;
      this.track.style.transform = `translate3d(${-nextIndex * 100}%, 0, 0)`;
      if (restart) {
        this.stop();
        this.start();
      }
    }

    start() {
      if (!this.autoplay || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stop();
      this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = undefined;
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('button, .sevenk-hero__actions a')) return;
      this.dragging = true;
      this.suppressClick = false;
      this.startX = event.clientX;
      this.deltaX = 0;
      this.slideWidth = this.getBoundingClientRect().width;
      this.track.classList.add('is-dragging');
      this.setPointerCapture?.(event.pointerId);
      this.stop();
    }

    onPointerMove(event) {
      if (!this.dragging) return;
      this.deltaX = event.clientX - this.startX;
      if (Math.abs(this.deltaX) > 8) this.suppressClick = true;
      const offset = -this.currentIndex * this.slideWidth + this.deltaX;
      this.track.style.transform = `translate3d(${offset}px, 0, 0)`;
    }

    onPointerUp(event) {
      if (!this.dragging) return;
      this.dragging = false;
      this.track.classList.remove('is-dragging');
      this.releasePointerCapture?.(event.pointerId);
      const threshold = Math.min(80, this.slideWidth * 0.15);
      let nextIndex = this.currentIndex;
      if (this.deltaX < -threshold) nextIndex += 1;
      if (this.deltaX > threshold) nextIndex -= 1;
      this.show(nextIndex, true);
    }
  }

  customElements.define('sevenk-hero-slider', SevenKHeroSlider);
}
